export const formatPhoneNumber = (value: string): string => `+${value.replace(/[()\s-]/g, '')}`;
